import { Check, Loader2, Minus, X } from 'lucide-react';
import type { FeeChain, FeeChainLink } from './feeAuditChain';

const STATE_WORD: Record<FeeChainLink['state'], string> = {
  done: 'Done',
  active: 'In progress',
  broken: 'Stopped',
  skipped: 'Skipped',
  waiting: 'Waiting'
};

function LinkIcon({ state }: { state: FeeChainLink['state'] }) {
  if (state === 'done') {
    return <Check size={13} aria-hidden="true" />;
  }
  if (state === 'active') {
    return <Loader2 size={13} className="fee-chain__spin" aria-hidden="true" />;
  }
  if (state === 'broken') {
    return <X size={13} aria-hidden="true" />;
  }
  if (state === 'skipped') {
    return <Minus size={13} aria-hidden="true" />;
  }
  return null;
}

/** The three-link verification chain. Words carry the state; icons and color only echo it. */
export function FeeAuditChain({ chain, compact = false, ariaLabel = 'Audit steps' }: { chain: FeeChain; compact?: boolean; ariaLabel?: string }) {
  return (
    <ol className={`fee-chain${compact ? ' fee-chain--compact' : ''}`} aria-label={ariaLabel}>
      {chain.links.map(link => (
        <li key={link.key} className={`fee-chain__link is-${link.state}`} data-fee-chain-link={link.key} data-state={link.state}>
          <span className="fee-chain__rail" aria-hidden="true" />
          <span className="fee-chain__dot"><LinkIcon state={link.state} /></span>
          <span className="fee-chain__text">
            <span className="fee-chain__label">{link.label}</span>
            <span className="fee-chain__meta">
              <span className="sr-only">{STATE_WORD[link.state]}. </span>
              {link.detail}
            </span>
          </span>
        </li>
      ))}
    </ol>
  );
}
